import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowRight, Box, ClipboardCheck, Flag, UserRoundPlus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TypedProperties } from '@/components/objects/TypedField';
import { ObjectCard } from '@/components/objects/ObjectCard';
import { CATALOG_DEFINITIONS, CATALOG_VALUES, INITIAL_OBJECTS, OBJECTS_HOME } from '../objects/model';
import { Section, Code } from './Section';
export function ObjectPatternsSection() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash !== '#object-patterns') return;
    let active = true;
    const align = () => {
      if (active)
        document.getElementById('object-patterns')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    const frame = requestAnimationFrame(align);
    void document.fonts.ready.then(align);
    return () => {
      active = false;
      cancelAnimationFrame(frame);
    };
  }, [hash]);
  const record = INITIAL_OBJECTS[0];
  return (
    <Section
      id="object-patterns"
      title="Поля и карточка объекта"
      lead="Одни типы свойств и одна карточка для любого сервиса. Панель, вкладка, второе окно и быстрый просмотр."
    >
      <div className="grid min-w-0 items-start gap-6 lg:grid-cols-2">
        <div className="min-w-0 rounded-lg border border-line bg-card p-5">
          <h3 className="mb-4 type-heading">Типизированные свойства</h3>
          <TypedProperties
            definitions={CATALOG_DEFINITIONS.filter((d) =>
              ['text', 'number', 'money', 'date', 'person', 'checkbox'].includes(d.id),
            )}
            values={CATALOG_VALUES}
            editable={false}
          />
          <p className="mt-4">
            <Code>TypedField · TypedProperties · FieldDefinition[] · valueAlignment</Code>
          </p>
          <Link
            to={OBJECTS_HOME + '/fields'}
            className="mt-4 inline-flex items-center gap-2 rounded-sm text-xs font-medium text-brand-fg hover:underline focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          >
            Все типы и правка полей
            <ArrowRight className="size-4" />
          </Link>
        </div>
        <div className="min-w-0 rounded-lg border border-line bg-card">
          <ObjectCard
            title={record.title}
            icon={<ClipboardCheck />}
            compact
            compactFieldIds={['subject', 'deadline', 'budget']}
            definitions={record.definitions}
            values={record.values}
            strip={[
              { fieldId: 'importance', icon: <Flag /> },
              { fieldId: 'status', icon: <ClipboardCheck /> },
              { fieldId: 'category', icon: <Box /> },
              { fieldId: 'owner', icon: <UserRoundPlus />, emptyLabel: 'Нет ответственного' },
            ]}
            actions={
              <Link
                to={OBJECTS_HOME}
                className="inline-flex h-9 items-center gap-2 rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
              >
                Открыть образец
                <ArrowRight className="size-4" />
              </Link>
            }
          />
          <p className="px-4 pb-4">
            <Code>
              ObjectCard · ObjectPropertyStrip · hideTitle · omitStripProperties · tabsOverflow ·
              compactHeader
            </Code>
          </p>
        </div>
      </div>
    </Section>
  );
}
